import type { PillarCardItem } from 'ui/organisms/PillarCards/PillarCards.types';

export const BAND_ITEMS: PillarCardItem[] = [
  {
    title: 'Registry expertise',
    description:
      'More than a decade of registry knowledge. We know how records get filed, how they change over time, and how to connect them across jurisdictions.',
  },
  {
    title: 'Full source transparency',
    description:
      'Every record shows its origin: the registry it came from, a link to the filing, and the date. You can trace any number back to the document behind it.',
  },
  {
    title: 'One focus',
    description: 'The whole business does one thing: global company information for the organisations that rely on it.',
  },
  {
    title: 'Independent by design',
    description:
      'Founder-owned and independent. Our decisions follow our customers and our mission, not an investor timetable.',
  },
];
export const HERO_BACKGROUND = 'linear-gradient(178deg, #EEF1FA 0%, #EEF1FA 30%, #DCE2F5 100%)';
